import styled from 'styled-components';

interface WrapperProps {
	width?: string;
	heigth?: string;
}

export const Wrapper = styled.div<WrapperProps>`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: ${({ width }) => (width ? width : 'auto')};
`;

interface DataContainerProps {
	moreThanOneItem?: boolean;
	lengthItems: number;
	currentPosition: number;
	backgroundColor?: string;
}

export const DataContainer = styled.div<DataContainerProps>`
	align-items: center;
	background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : '#fff')};
	border-radius: ${({ currentPosition, moreThanOneItem, lengthItems }) =>
		!moreThanOneItem
			? '12px'
			: currentPosition === 0
			? '12px 12px 0 0'
			: currentPosition === lengthItems - 1
			? '0 0 12px 12px'
			: ''};
	display: flex;
	height: 100%;
	justify-content: space-between;
	padding: 12px;
	width: 100%;
`;

export const HeaderTitle = styled.div`
	align-items: center;
	display: flex;
	gap: 8px;
`;

interface TitleProps {
	fontSize?: string;
}

export const Title = styled.h2<TitleProps>`
	color: ${({ theme }) => theme.colors.extra.space_700};
	font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
	font-style: normal;
	font-weight: 600;
	letter-spacing: 0.24px;
	line-height: normal;
	text-transform: uppercase;
`;

export const ContainerIconSubtitle = styled.div`
	align-items: center;
	display: flex;
	gap: 4px;
	justify-content: flex-end;
	max-width: 40%;
	width: 100%;
`;

interface SubTitleProps {
	textAlign?: 'start' | 'end' | 'center' | 'justify';
	fontSize?: string;
}

export const SubTitle = styled.p<SubTitleProps>`
	color: ${({ theme }) => theme.colors.extra.space_700};
	font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	max-width: 60%;
	overflow-x: hidden;
	text-align: ${({ textAlign }) => textAlign || 'start'};
	text-overflow: ellipsis;

	:hover {
		word-break: break-word;
	}
`;
